import { Component, OnInit } from '@angular/core';
import { ConfirmacaoService, MensagemService, ProgressoService, Restricao, RestricaoOperador, Restricoes } from 'maestro-ng';
import { SelectItem } from 'primeng/api/selectitem';
import { SelectItemService } from '../../services/select-item.service';
import { RecursoSeguranca } from '../recurso-seguranca.model';
import { RecursoSegurancaService } from '../recurso-seguranca.service';
import { DataSourceRouted } from '../../util/data-source-routed';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-recurso-seguranca-lista',
  templateUrl: './recurso-seguranca-lista.component.html',
  styleUrls: ['./recurso-seguranca-lista.component.css'],
})
export class RecursoSegurancaListaComponent implements OnInit {
  ds: DataSourceRouted<RecursoSeguranca, number>;
  requerAutenticacoesItens: SelectItem[];
  selecaoRequerAutenticacao: boolean;

  public dominioItens: SelectItem[];
  public metodoItens: SelectItem[];

  constructor(
    private service: RecursoSegurancaService,
    private confirmacaoService: ConfirmacaoService,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private selectItemService: SelectItemService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.ds = new DataSourceRouted<RecursoSeguranca, number>(
      'administracao-recurso-seguranca',
      (c) => this.service.recuperarPaginado(c),
      this.mensagemService,
      this.progressoService,
      this.route,
      this.router,
      15,
      new Restricoes([
        new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
        new Restricao<string>({ atributo: 'nome', operador: RestricaoOperador.CONTAINS }),
        new Restricao<string>({ atributo: 'dominio', operador: RestricaoOperador.IN }),
        new Restricao<string>({ atributo: 'metodo', operador: RestricaoOperador.IN }),
        new Restricao<boolean>({ atributo: 'requerAutenticacao', operador: RestricaoOperador.IN }),
      ])
    );
  }

  ngOnInit(): void {
    this.requerAutenticacoesItens = this.selectItemService.getSimNaoItens();
    this.dominioItens = this.selectItemService.getDominios();
    this.metodoItens = this.selectItemService.getMetodos();
  }

  startDelete(entity: RecursoSeguranca): void {
    this.confirmacaoService.confirmar({
      mensagem: 'Você tem certeza que deseja excluir o objeto?',
      aceitar: () => {
        this.service
          .excluir(entity)
          .then(() => {
            this.ds.atualizar();
          })
          .catch((response) => {
            this.mensagemService.addErro('Erro', response.error);
          });
      },
    });
  }
}
